import { useAppStore } from '@/app/stores/app.store.js';
import { hydrate } from '@/app/services/hydrate.js';
import { useAuthStore } from '#modules/auth/stores/auth.store.js';

let firstLoad = true;

/**
 * Initialization guard - handles app bootstrap and store hydration
 *
 * This guard:
 * - Initializes the app on first load (token refresh, etc)
 * - Ensures stores are hydrated when authenticated
 *
 * MUST run FIRST before all other guards
 */
export async function initializationGuard() {
    const appStore = useAppStore();
    const authStore = useAuthStore();

    if (firstLoad) {
        firstLoad = false;
        await appStore.initialize();
        return;
    }

    // Ensure the app is hydrated if access token is present
    if (appStore.hydrated === false && appStore.hydrating === false) {
        if (authStore.accessToken) {
            try {
                await hydrate();
            } catch {
                // hydrate() already set appStore.error
            }
        }
    }
}
